import { createContext, useContext } from "react";

/**
 * What choosing a row in a people picker does, in the words its button uses.
 *
 * The same picker adds somebody to a team in one place and names who bills a rate in another, so the
 * words are the host's. The context carries them to every tab of a picker at once, including the
 * marketplace's results, which are four components below whoever opened it. Its own module, apart
 * from `row-choice`, so a host can set it without importing the avatar and the store behind it.
 */
export const DEFAULT_ROW_CHOICE_LABEL = "Add To Team";
/** What a row that is already chosen says in place of the choice. */
export const ROW_ALREADY_CHOSEN_LABEL = "On Team";

export const RowChoiceLabel = createContext(DEFAULT_ROW_CHOICE_LABEL);

export function useRowChoiceLabel(): string {
  return useContext(RowChoiceLabel);
}
